import React, { useState } from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import JoinWaitlist from './JoinWaitlist';

const Footer = () => {
  
  const [isJoinWaitlistModalOpen, setIsJoinWaitlistModalOpen] = useState(false);

  const openJoinWaitlistModal = () => {
    setIsJoinWaitlistModalOpen(true);
  };

  const closeJoinWaitlistModal = () => {
    setIsJoinWaitlistModalOpen(false);
  };

  return (
    <>
      <div className='footer-container'>
        {/* <img src='' */}
        <div className='footer-top-image'></div>
        <div className='footer-bottom'>
          <div className='footer-menu-container'>
            <div className='footer-logo-container'>
              <Link to="/" className='footer-logo'>
                <img src='/assets/rairer-logo-footer.svg' alt="rairer" />
              </Link>
              <div className='footer-contact'>
                <a href="mailto:hello@rairer.com" className="footer-email">
                  Email: hello@rairer.com
                </a>
                <a href='https://wa.link/14064e' style={{color: 'white', textDecorationLine: 'none'}} target="_blank" rel="noopener noreferrer">
                  <p className='footer-contact-p'>Phone: +2349032549756</p>
                </a>
              </div>
            </div>
            {/* <div className='footer-links'> */}
              <div className='footer-menu company'>
                <h4>Company</h4>
                <div className='menu-container'>
                  <Link to='/#about' className='menu-navLinks'>About Us</Link>
                  <Link onClick={openJoinWaitlistModal} className='menu-navLinks'>Products & Waitlist</Link>
                </div>
              </div>
              <div className='footer-menu legal'>
                <h4>Legal Information</h4>
                <div className='menu-container'>
                  <Link to='/privacy-policy' className='menu-navLinks'>Privacy Policy</Link>
                  <Link to='/terms' className='menu-navLinks'>Terms of Use</Link>
                </div>
              </div>
              <div className='footer-menu connect'>
                <h4>Connect With Us</h4>
                <div className='footer-socials'>
                  <a href='https://www.facebook.com/rairerapp' target="_blank" rel="noopener noreferrer" className='footer-socials'><img src="/assets/facebook.svg" alt='facebook'/></a>
                  <a href='https://www.twitter.com/rairerapp' target="_blank" rel="noopener noreferrer" className='footer-socials'><img src="/assets/twitter.svg" alt='twitter'/></a>
                  <a href='https://www.instagram.com/rairerapp' target="_blank" rel="noopener noreferrer" className='footer-socials'><img src="/assets/instagram.svg" alt='instagram'/></a>
                  <a href='https://www.linkedin.com/company/rairerapp' target="_blank" rel="noopener noreferrer" className='footer-socials'><img src="/assets/linkedin.svg" alt='linkedin'/></a>
                </div>
              </div>
            {/* </div> */}
          </div>
          <div className='copright-container'>
            <p>© 2025 Rairer Dynamics Limited. All Rights Reserved.</p>
          </div>
        </div>
      </div>      
      {isJoinWaitlistModalOpen && (
        <JoinWaitlist closeJoinWaitlistModal={closeJoinWaitlistModal}/>
      )}
    </>
  );
};



export default Footer;
